export default [
  {
    key: 'cooperation_agreement',
    title: 'Kooperationsvereinbarung',
    dates: [
      {
        color: '#E64A19',
        values: [
          {
            keyTree: ['dispatch_documents_till_date'],
            name: 'Kooperationsunterlagen versendet',
          },
          {
            keyTree: ['gr_meeting_date'],
            name: 'Gemeinderatsbeschluss',
          },
        ],
      },
    ],
  },
  {
    key: 'mev',
    title: 'Markterkundungsverfahren (MEV)',
    dates: [
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2022', 'start_date'],
            name: 'Start MEV 1.0',
          },
          {
            keyTree: ['2022', 'end_date'],
            name: 'Ende MEV 1.0',
          },
          {
            keyTree: ['2022', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 1.0',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2023', 'start_date'],
            name: 'Start MEV 2.0',
          },
          {
            keyTree: ['2023', 'end_date'],
            name: 'Ende MEV 2.0',
          },
          {
            keyTree: ['2023', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.0',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2024', 'start_date'],
            name: 'Start MEV 2.1',
          },
          {
            keyTree: ['2024', 'end_date'],
            name: 'Ende MEV 2.1',
          },
          {
            keyTree: ['2024', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.1',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2024_1', 'start_date'],
            name: 'Start MEV 2.1 Wdh.',
          },
          {
            keyTree: ['2024_1', 'end_date'],
            name: 'Ende MEV 2.1 Wdh.',
          },
          {
            keyTree: ['2024_1', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.1 Wdh.',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2024_2', 'start_date'],
            name: 'Start MEV 2.2',
          },
          {
            keyTree: ['2024_2', 'end_date'],
            name: 'Ende MEV 2.2',
          },
          {
            keyTree: ['2024_2', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.2',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2025', 'start_date'],
            name: 'Start MEV 2.2 (Wdh.)',
          },
          {
            keyTree: ['2025', 'end_date'],
            name: 'Ende MEV 2.2 (Wdh.)',
          },
          {
            keyTree: ['2025', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.2 (Wdh.)',
          },
        ],
      },
      {
        color: '#FF8F00',
        values: [
          {
            keyTree: ['2026', 'start_date'],
            name: 'Start MEV 2.3',
          },
          {
            keyTree: ['2026', 'end_date'],
            name: 'Ende MEV 2.3',
          },
          {
            keyTree: ['2026', 'publish_date_mev'],
            name: 'Veröffentlichung MEV 2.3',
          },
        ],
      },
    ],
  },
  {
    key: 'grant_applications',
    title: 'Förderantrag',
    dates: [
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2000', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt WF',
          },
          {
            keyTree: ['2000', 'state_application_made_date'],
            name: 'Antrag Land gestellt WF',
          },
          {
            keyTree: ['2000', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt WF',
          },
          {
            keyTree: ['2000', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt WF',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2022', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 1.0',
          },
          {
            keyTree: ['2022', 'state_application_made_date'],
            name: 'Antrag Land gestellt 1.0',
          },
          {
            keyTree: ['2022', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 1.0',
          },
          {
            keyTree: ['2022', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 1.0',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2023', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.0',
          },
          {
            keyTree: ['2023', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.0',
          },
          {
            keyTree: ['2023', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.0',
          },
          {
            keyTree: ['2023', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.0',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2024', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.1',
          },
          {
            keyTree: ['2024', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.1',
          },
          {
            keyTree: ['2024', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.1',
          },
          {
            keyTree: ['2024', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.1',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2024_1', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.1 (Wdh.)',
          },
          {
            keyTree: ['2024_1', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.1 (Wdh.)',
          },
          {
            keyTree: ['2024_1', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.1 (Wdh.)',
          },
          {
            keyTree: ['2024_1', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.1 (Wdh.)',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2024_2', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.2',
          },
          {
            keyTree: ['2024_2', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.2',
          },
          {
            keyTree: ['2024_2', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.2',
          },
          {
            keyTree: ['2024_2', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.2',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2025', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.2 (Wdh.)',
          },
          {
            keyTree: ['2025', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.2 (Wdh.)',
          },
          {
            keyTree: ['2025', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.2 (Wdh.)',
          },
          {
            keyTree: ['2025', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.2 (Wdh.)',
          },
        ],
      },
      {
        color: '#9E9D24',
        values: [
          {
            keyTree: ['2026', 'federal_application_made_date'],
            name: 'Antrag Bund gestellt 2.3',
          },
          {
            keyTree: ['2026', 'state_application_made_date'],
            name: 'Antrag Land gestellt 2.3',
          },
          {
            keyTree: ['2026', 'federal_notice_from_date'],
            name: 'Antrag Bund vorläufig bewilligt 2.3',
          },
          {
            keyTree: ['2026', 'state_notice_from_date'],
            name: 'Antrag Land vorläufig bewilligt 2.3',
          },
        ],
      },
    ],
  },
  {
    key: 'tenders_mains_operation',
    title: 'Ausschreibung Netzbetrieb',
    dates: [
      {
        color: '#388E3C',
        values: [
          {
            keyTree: ['start_date_net'],
            name: 'Start der Ausschreibungsvorbereitung'
          },
          {
            keyTree: ['publish_date_net'],
            name: 'Veröffentlichung der Ausschreibung',
          },
          {
            keyTree: ['end_date_net'],
            name: 'Enddatum'
          },
        ],
      },
    ],
  },
  {
    key: 'tenders_planning',
    title: 'Ausschreibung Planung',
    dates: [
      {
        color: '#40a69d',
        values: [
          {
            keyTree: ['start_date_planning'],
            name: 'Start der Ausschreibungsvorbereitung'
          },
          {
            keyTree: ['publish_date_planning'],
            name: 'Veröffentlichung der Ausschreibung',
          },
          {
            keyTree: ['end_date_planning'],
            name: 'Enddatum'
          },
        ],
      },
    ],
  },
  {
    key: 'tenders_construction',
    title: 'Ausschreibung Planung/Bau (GÜ)',
    dates: [
      {
        color: '#00796B',
        values: [
          {
            keyTree: ['start_date_construction'],
            name: 'Start der Ausschreibungsvorbereitung (Bau)'
          },
          {
            keyTree: ['publish_date_construction'],
            name: 'Veröffentlichung der Ausschreibung (Bau)',
          },
          {
            keyTree: ['end_date_construction'],
            name: 'Enddatum (Bau)'
          },
        ]
      },
      {
        color: '#00796B',
        values: [
          {
            keyTree: ['start_date_white_spots'],
            name: 'Start der Ausschreibungsvorbereitung (WF)'
          },
          {
            keyTree: ['publish_date_white_spots'],
            name: 'Veröffentlichung der Ausschreibung (WF)',
          },
          {
            keyTree: ['end_date_white_spots'],
            name: 'Enddatum (WF)'
          },
        ]
      }
    ],
  },
  // {
  //   key: 'planning_construction_general_contractor',
  //   title: 'Planung und Bau (GÜ)',
  //   dates: [
  //     {
  //       color: '#0097A7',
  //       values: [
  //         {
  //           keyTree: ['opening_conversation_date'],
  //           name: 'Auftaktgespräch GÜ',
  //         },
  //         {
  //           keyTree: ['initial_consultation_municipality_date'],
  //           name: 'Erstgespräch Kommune',
  //         },
  //         {
  //           keyTree: ['retrieval_date_date'],
  //           name: 'Abruf',
  //         },
  //         {
  //           keyTree: ['start_date_planning_date'],
  //           name: 'Beginn Planungsphase',
  //         },
  //         {
  //           keyTree: ['end_date_planning_date'],
  //           name: 'Ende Planungsphase',
  //         },
  //       ],
  //     },
  //     {
  //       color: '#bee5ec',
  //       values: [
  //         {
  //           keyTree: ['start_date_construction_date'],
  //           name: 'Start Bauphase',
  //         },
  //         {
  //           keyTree: ['end_date_construction_date'],
  //           name: 'Ende Bauphase',
  //         },
  //       ],
  //     },
  //   ],
  // },
];
